module.exports = __webpack_public_path__ + "img/sampdoria.359e40f9.png";